"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DayContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

const DayContainer = _styledComponents.default.div.withConfig({
  displayName: "DayElementstyles__DayContainer"
})(["z-index:2;"]);

exports.DayContainer = DayContainer;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJEYXlDb250YWluZXIiLCJzdHlsZWQiLCJkaXYiXSwic291cmNlcyI6WyIuLi8uLi8uLi8uLi8uLi9zcmMvY29tcG9uZW50cy9EYXRlUGlja2VyL2NvbXBvbmVudHMvRGF5RWxlbWVudC9EYXlFbGVtZW50LnN0eWxlcy50cyJdLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgc3R5bGVkIGZyb20gJ3N0eWxlZC1jb21wb25lbnRzJ1xuXG5leHBvcnQgY29uc3QgRGF5Q29udGFpbmVyID0gc3R5bGVkLmRpdmBcbiAgei1pbmRleDogMjtcbmBcbiJdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUE7O0FBRU8sTUFBTUEsWUFBWSxHQUFHQyx5QkFBQSxDQUFPQyxHQUFWO0VBQUE7QUFBQSxrQkFBbEIifQ==